import { Group, Stack, Text } from "@mantine/core";
import { Badge, Card } from "@xplatform/design-system";
import { useTranslation } from "react-i18next";
import type { PublicReleaseNote } from "@models/releaseNotes";
import { useLocalized } from "@utils/localizedText";
import { ChangeList } from "@components/ChangeList";

interface Props {
  note: PublicReleaseNote;
}

/**
 * One released version.
 *
 * The version is the heading, because that is the unit a reader is looking for:
 * "what shipped in 2026.07". The product and the date sit beside it, and the
 * changes are grouped by kind underneath.
 */
export const ReleaseNoteCard = ({ note }: Props) => {
  const { t } = useTranslation();
  const { pick, formatDate } = useLocalized();

  return (
    <Card>
      <Stack gap="md">
        <Stack gap={6}>
          <Group gap="sm" align="center" wrap="wrap">
            <Text component="h2" size="lg" fw={700}>
              {note.version}
            </Text>
            <Badge>{t(`releases.module.${note.module}`)}</Badge>
            <Text size="sm" c="dimmed">
              {formatDate(note.released_at)}
            </Text>
          </Group>
          <Text fw={600}>{pick(note.title)}</Text>
          {pick(note.highlight) && (
            <Text size="sm" c="dimmed">
              {pick(note.highlight)}
            </Text>
          )}
        </Stack>

        <ChangeList changes={note.changes} />
      </Stack>
    </Card>
  );
};
